// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fn-3";
export var flatBottomCorners = "_fn-5";
export var productImage = "_fn-0";
export var quantityContainer = "_fn-2";
export var quantityHeader = "_fn-6";
export var tooltip = "_fn-1";
export var wrapAndEllipsesOverflow = "_fn-4";